import axios from "axios";
import ReactGA from "react-ga";

export const setHeaders = (provider) => {
  switch (provider) {
    case "bit": {
      axios.defaults.headers.common["X-SITE-ID"] =
        "43a31578-d0c4-5aeb-f1bc-c8c33b3cedb7";
      break;
    }
    case "leumi": {
      axios.defaults.headers.common["X-SITE-ID"] =
        "f4fd98c5-c456-4689-b4dc-794bffc679bc";
      break;
    }
    default: {
      axios.defaults.headers.common["X-SITE-ID"] =
        "ca9475f8-c727-4010-89ca-0537d7d2b1a2";
      break;
    }
  }
  axios.defaults.headers.common["Content-Type"] = "application/json";
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
};
export const setTokenHeader = (token) => {
  axios.defaults.headers.common["Authorization"] =
    "CALAuthScheme" + " " + token;
};

export const sendOtp = (
  idNum,
  last4Digits,
  byVoice,
  source,
  provider,
  captcha
) => {
  let url =
    window.settings.api.baseDigitalUrl + "/authentication/api/login/sendotp";
  return axios.put(url, {
    custExtId: idNum,
    last4Digits: last4Digits,
    smsByVoice: byVoice,
  });
};
export const dd = () => {
  this.ur;
};
export const verifyOtp = (token, otpCode) => {
  let url =
    window.settings.api.baseDigitalUrl + "/authentication/api/login/verifyotp";
  return axios.post(url, { token: token, password: otpCode });
};

export const init = () => {
  let url =
    window.partnerId !== "null" && window.partnerId
      ? `${window.settings.api.baseUrl}/inituseraccount?partnerId=${window.partnerId}`
      : `${window.settings.api.baseUrl}/inituseraccount`;
  return axios.get(url);
};
export const getCards = () => {
  let url = window.settings.api.baseUrl + "/getPinRetrievalEligibility";
  return axios.get(url);
};

export const requestExpressToken = (last4Digits) => {
  let url = window.settings.api.baseUrl + "/authentication/express";
  return axios.post(url, { last4Digits });
};

export const getPin = (last4Digits) => {
  let url = window.settings.api.baseUrl + "/getPinCode";
  return axios.post(url, { last4Digits });
};
export const getSSO = () => {
  let url =
    window.settings.api.baseDigitalUrl + "/authentication/api/sso/SetSSO";
  return axios.get(url);
};
export const getToken = (index) => {
  let url =
    window.settings.api.calConnectUrl +
    `/authentication/SSO?sid=${index}`;
  return axios.get(url);
};
export const goToUrl = (url) => {
  window.location.href = url;
};

export const applyProviderConfigurations = (provider) => {
  //theme
  let providerTheme = document.createElement("link");
  providerTheme.rel = "stylesheet";
  providerTheme.type = "text/css";
  providerTheme.href = "themes/" + provider + "/theme.css";
  document.head.append(providerTheme);

  //settings
  let providerSettings = document.createElement("script");
  providerSettings.src = "themes/" + provider + "/settings.js";
  providerSettings.onload = () => {
    window.settings.provider = window.getProviderSettings();
  };
  document.head.append(providerSettings);
};

export const getFromQueryString = (parameter, url) => {
  var href = url ? url : window.location.href;
  var reg = new RegExp("[?&]" + parameter + "=([^&#]*)", "i");
  var string = reg.exec(href);
  return string ? string[1] : null;
};

export const trim = (val, char) => {
  if (char === undefined) char = "s";

  let leftTrim = val.replace(new RegExp("^[" + char + "]+"), "");
  let rightTrim = leftTrim.replace(new RegExp("[" + char + "]+$"), "");
  return rightTrim;
};

export const isMobile = () => {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export const callGa = (page, error) => {
  let platform = isMobile();
  let pageName = "/vp/" + window.settings.ga.site + "/" + page;

  if (platform) pageName += "/?device=mobile";
  if (error) {
    error = error.replace(/\||#|@/g, "");
    if (platform) pageName += "&";
    else pageName += "/?";
    pageName += "error=" + error;
  }
  var campaignName = getFromQueryString("utm_campaign");
  var campaignContent = getFromQueryString("utm_content");
  var campaignMedium = getFromQueryString("utm_medium");
  var campaignSource = getFromQueryString("utm_source");
  var campaignTerm = getFromQueryString("utm_term");

  if (campaignName) ReactGA.set({ campaignName: campaignName });

  if (campaignContent) ReactGA.set({ campaignContent: campaignContent });

  if (campaignMedium) ReactGA.set({ campaignMedium: campaignMedium });

  if (campaignSource) ReactGA.set({ campaignSource: campaignSource });

  if (campaignTerm) ReactGA.set({ campaignTerm: campaignTerm });

  ReactGA.pageview(pageName);
};

export const callGaEvent = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};



// WEBPACK FOOTER //
// ./src/actions/services.js